import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { Checkbox, CircularProgress, Fab, FormControl, FormControlLabel, Grid, Icon, InputLabel, MenuItem, Select, ListItem, ListItemText, ListItemAvatar, Avatar, ListItemSecondaryAction, List, Typography, Button, Tooltip } from '@material-ui/core';
import Title from '../components/Complements/Title';
import { feathersFindDataAll } from '../services';
import moment from 'moment'
import SelectForm from '../components/Complements/SelectForm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { history } from '../helpers/history';
import { Tbody, Td, Th, Thead, Tr, Table } from 'react-super-responsive-table';
import { Alert, Pagination } from '@material-ui/lab';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import StandardDialog from '../components/Complements/StandardDialog';
import { consolidateReportPDF } from '../functions/consolidate-report';


const PayRollActivityContainer = props => {
    const { company, classes, states, handleOpenSnack, user } = props
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))
    const [ loading, setLoading ] = useState(false)
    const [ accountSelected, setAccountSelected ] = useState(company[0])
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ payrollspaginate, setPayrollsPaginate ] = useState([])
    const [ payrollsTray, setPayrollsTray ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    const [ filters, setFilters ] = useState({ approve: true, earring: true, timeOut: true, invalid: true, reject: true})
    const [ dialog, setDialog ] = useState({ open: false, title: '', content: <div></div>});

    const mount = () => {
        const unmount = () => {
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
        }
        return unmount()
    }
    useEffect(mount, []) 
    const getDataViewTable = (total, numberpage) => {
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;
        if(residuo > 0){
            contador++;
        }
        setCount(contador)
        setPage(numberpage)
    }
    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage) => {
        try {
            setLoading(true)
            // console.log(accountSelected)
            feathersFindDataAll('payrolls-tray', { cedule: accountSelected.cedule, createdAt: { $lte: valuedateEnd, $gte: valuedateStart }})().then(res => {
                //console.log('payrolls-tray', res)
                setPayrollsPaginate(res)
                setPayrollsTray(res)
                setLoading(false)
                getDataViewTable(res.length, numberpage);
            }).catch( err => {
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
        }
    }
    const handleSelectCode = (val) => {
        // console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)
            let selectMonth = new Date(obj.year, obj.month, 1)
            setDateStart(moment(selectMonth).startOf('month'))
            setDateEnd(moment(selectMonth).endOf('month'))
            //filterCodesByDate(dateStart, dateEnd, allcodes)
            setDateValue(val)
            setLoading(false)
            handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1)
        }
        
    }
    const handleSubmit = (val) => {
        // console.log(val)
    }
    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }
    const handleFindRange = () => {
        if (!isEmpty(accountSelected)) {
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
        } else {
            handleOpenSnack('Seleccione una cuenta a buscar', 'error')
        }
    }
    const onChangePaginationPayroll = (e, numberpage) => {
        handleGetDataMovementsBySecuencialAccount((numberpage - 1)*10, dateStart, dateEnd, numberpage);
    }
    const handleAccountFind = (value) => {
        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1)
    }

    const renderDetailValidator = (row) => {

        return  <Typography >
                    <b>{ `Estado: `}</b>{ `${filterArrayEqual(states, 'id', row.state)[0].name} `}
                    <br />
                    <b>{ `Observacion: `}</b>{ `${row.observation.trim() === '' ? 'SIN ACTIVIDAD' : row.observation } `}
                    <br />
                </Typography>
    }
    const handleOpenListDialog = (validators) => {
        try {
            setDialog( { open: true, title: 'VALIDADORES', 
            content: <List >
                    {
                        validators.map((validator) => {
                            return <Grid container spacing={3} key={validator.id}>
                                        <Grid item xs={12} md={12} lg = {6} sm = {12}>
                                            <ListItem  >
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <Icon>account_circle</Icon>
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={`${JSON.parse(validator.body).name}`} secondary={renderDetailValidator(validator)} />
                                                <ListItemSecondaryAction>
                                                    <Icon>{filterArrayEqual(states, 'id', validator.state)[0].icon}</Icon>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        </Grid>
                                    </Grid>
                        })
                    }

                    </List>
        
            })
        } catch (error) {
            //console.log(error)
        }
    }
    const handleOpenListEmployees = (arrayErrors, id, row) => {
        try {
            const arr = JSON.parse(arrayErrors)
            setDialog( { open: true, title: 'DETALLE ROL', 
            content: <Fragment>
                <br/>
                        <Button 
                          color="primary"
                           variant="contained"
                        onClick={ () =>  consolidateReportPDF(arr.data, id, dateStart, user,arr, row) } >

                            {/* <img src={'./../../../icons/Voucher_Consolidado.png'} alt="Logo" style={{ width: `auto`,height: `50px`}}  /> */}
                            Descargar Consolidado
                            </Button>
                            <br/>

                        <List >
                            {
                                arr.data.map((errObject) => {
                                    return <Grid container spacing={3} key={errObject.rolId}>
                                                <Grid item xs={12} md={12} lg = {6} sm = {12}>
                                                    <ListItem  >
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <Icon>account_circle</Icon>
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText primary={` ${errObject.name.toUpperCase()}`}
                                                            secondary={
                                                            <div>
                                                                <b>{ `Identificación: `}</b>{ `${errObject.identification} `}
                                                                <br/>
                                                                <b>{ `Monto: `}</b>{ `$ ${errObject.value} `}
                                                                <br/>
                                                                {
                                                                    errObject.error ?
                                                                    <span><b style={{color:'red'}}>{ `ERROR DE TRANSFERENCIA: `}</b>{ `${ errObject.message ? errObject.message.toUpperCase():  errObject.data.Message ?  errObject.data.Message.toUpperCase() : "ERROR" }`} </span>:
                                                                    <b style={{color:'#6fac22'}}>{ `${errObject.message ? errObject.message.toUpperCase() :   errObject.data.Message ?  errObject.data.Message.toUpperCase() : "ERROR" }`}</b> 
                                                                }
                                                            </div>
                                                            } />
                                                    </ListItem>
                                                </Grid>
                                            </Grid>
                                })
                            }
                        </List>
                    </Fragment>
        
            })
        } catch (error) {
            //console.log(error)
        }
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (payrollspaginate.length > 0) {
                return  <div>
                            <Grid item xs={12} md={12} lg = {12}>
                                <Table>
                                    <Thead>
                                        <Tr>
                                            <Th>Propietario</Th>
                                            <Th>Valor</Th>
                                            <Th>Tipo de pago</Th>
                                            <Th className = { "colunmvalue"}>Concepto</Th>
                                            <Th className = { "colunmvalue"}>Estado</Th>
                                            <Th className = { "colunmvalue"}>Accion</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        { 
                                            payrollspaginate.map(row => (
                                                <Tr key={`${row.id}`}>
                                                    <Td>{accountSelected.name}</Td>
                                                    <Td>$ {row.value}</Td>
                                                    <Td>{accountSelected.pay_type}</Td>
                                                    <Td>{row.concept}</Td>
                                                    <Td style={{color: row.state !== undefined ? filterArrayEqual(states, 'id', row.state)[0].color : '#FFFFFF',fontWeight: 'bold' }}>{ row.state !== undefined ? filterArrayEqual(states, 'id', row.state)[0].name : ''}</Td>
                                                    <Td>
                                                        <Tooltip 
                                                            arrow
                                                            title={'Aprobadores'}
                                                        >
                                                            <Fab  size="small" color="primary" aria-label="add" onClick= { () => handleOpenListDialog(row.validators)} >
                                                                <Icon>search</Icon>
                                                            </Fab>
                                                        </Tooltip>
                                                        {(row.state === 2 && row.body !== ' ') && 
                                                        <Tooltip
                                                            arrow
                                                            title={'Comprobante'}
                                                        >
                                                            <Fab  size="small" color="primary" aria-label="add" onClick= { () =>{ handleOpenListEmployees(row.body, row.id, row)}} >
                                                                <Icon>description</Icon>
                                                            </Fab>
                                                        </Tooltip>
                                                        }
                                                    </Td>
                                                </Tr>
                                            ))
                                        }
                                    </Tbody>
                                </Table>
                                <Pagination 
                                    count = { count } 
                                    color = "primary" 
                                    page = { page }
                                    onChange = { onChangePaginationPayroll }
                                />
                            </Grid>
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado pagos de préstamos en el mes seleccionado.</Alert>
            }
        }
    }

    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg = {12} sm = {12}>
                            <Title>Detalle de pago de nominas  </Title>
                        </Grid>
                        <Grid item xs={12} md={12} lg = {12} sm = {12}>
                            <SelectForm
                                name = { 'Período' }
                                label = { 'Seleccione período '}
                                // data = { [{ id: '1', name: 'data'}] }
                                classes = { classes }
                                dateValue = { dateValue }
                                onSelected = { (val) => handleSelectCode(val)}
                                onSubmit={ handleSubmit }
                            ></SelectForm>
                        </Grid>
                        <Grid item xs={12} md={12} lg = {12} sm = {12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" style= {{ backgroundColor:'#8EAB40'}} aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                    <Icon>close</Icon>
                                </Fab>
                            </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={2} sm={12} xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={filters.approve}
                                    onChange={(e) => {
                                        if (!e.target.checked) {
                                            setPayrollsPaginate( payrollspaginate.filter(p => p.state !== 2))
                                        } else {
                                            setPayrollsPaginate([...payrollspaginate,  ...payrollsTray.filter(p => p.state === 2)])
                                        }
                                        setFilters({...filters, approve: !filters.approve})
                                        
                                    }}
                                    name="checkedB"
                                    color="primary"
                                />
                                }
                                label="Verificado"
                            />
                        </Grid>
                        <Grid item md={2} sm={12} xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={filters.earring}
                                    onChange={(e) => {
                                        if (!e.target.checked) {
                                            setPayrollsPaginate( payrollspaginate.filter(p => p.state !== 1))
                                        } else {
                                            setPayrollsPaginate([...payrollspaginate,  ...payrollsTray.filter(p => p.state === 1)])
                                        }
                                        setFilters({...filters, earring: !filters.earring})
                                        
                                    }}
                                    name="checkedB"
                                    color="primary"
                                />
                                }
                                label="Pendientes"
                            />
                        </Grid>
                        <Grid item md={2} sm={12} xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={filters.timeOut}
                                    onChange={ (e) => {
                                        if (!e.target.checked) {
                                            setPayrollsPaginate( payrollspaginate.filter(p => p.state !== 3))
                                        } else {
                                            setPayrollsPaginate([...payrollspaginate,  ...payrollsTray.filter(p => p.state === 3)])
                                        }
                                        setFilters({...filters, timeOut: !filters.timeOut})
                                    }}
                                    name="checkedB"
                                    color="primary"
                                />
                                }
                                label="Caducados"
                            />
                        </Grid>
                        <Grid item md={2} sm={12} xs={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={filters.reject}
                                    onChange={(e) => {
                                        if (!e.target.checked) {
                                            setPayrollsPaginate( payrollspaginate.filter(p => p.state !== 5))
                                        } else {
                                            setPayrollsPaginate([...payrollspaginate,  ...payrollsTray.filter(p => p.state === 5)])
                                        }
                                        setFilters({...filters, reject: !filters.reject})
                                        
                                    }}
                                    name="checkedB"
                                    color="primary"
                                />
                                }
                                label="Rechazado"
                            />
                        </Grid>
                        <Grid item md={3} sm={12} xs={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={filters.invalid}
                                        onChange={(e) => {
                                            if (!e.target.checked) {
                                                setPayrollsPaginate( payrollspaginate.filter(p => p.state !== 4))
                                            } else {
                                                setPayrollsPaginate([...payrollspaginate,  ...payrollsTray.filter(p => p.state === 4)])
                                            }
                                            setFilters({...filters, invalid: !filters.invalid})
                                            
                                        }}
                                        name="checkedB"
                                        color="primary"
                                    />
                                    }
                                    label="No válido "
                                />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} justify="center" alignItems="center">
                        <Grid item md={12} sm={12} xs={12}>
                            {renderTableMovements()}
                        </Grid>
                    </Grid>
                </div>
    }
    const renderHeader = () => {
        return  <Grid container spacing={3} justify="center" alignItems="center">
                    <Grid item md={12} sm={12} xs={12}>
                        <FormControl variant="outlined" >
                            <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                            <Select
                            label="Seleccione una Cuenta"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={company.length > 0 ? accountSelected : undefined}
                            onChange={(e) => handleAccountFind(e.target.value) }
                            >
                                {
                                    company.map(option => {
                                        return <MenuItem key={option.id} value={option}>{`${option.name} - ${option.number_account}`}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                info = { renderHeader()}
                multiple = { true }
                panel = {2}
            />
            <StandardDialog
                open = {dialog.open}
                title = {dialog.title}
                handleClose = { () => setDialog({...dialog, open: false}) } >
                {dialog.content}
            </StandardDialog>
            <LoadingScreen open={loading} />
        </div>
    );
};

PayRollActivityContainer.propTypes = {
    company: PropTypes.array.isRequired,
};

export default PayRollActivityContainer;